// ============================================================================
// page-service / form.js
// ----------------------------------------------------------------------------
// Populate the CF7 hidden `#from-page` field with the service title so each
// consultation lead carries which service page it came from.
//
// Bugfix vs the original inline JS: it read `.service-hero__title`, which
// doesn't exist on this template. The hero title here is `.services__title`
// (see Headline #4). We prefer `.services__title` and fall back to
// `.service-hero__title` so the module still works on any sibling templates
// that happen to use the older class.
// ============================================================================

document.addEventListener("DOMContentLoaded", function () {
  const fromPageInput = document.querySelector("#from-page");
  const heroTitle =
    document.querySelector(".services__title") ||
    document.querySelector(".service-hero__title");

  if (!fromPageInput || !heroTitle) return;

  fromPageInput.value = heroTitle.innerText.trim();
});
